// @flow

import { type Receipt } from './types';
import { useIncomingPayment, getFinalReceipt, getReceipts, getStatus } from '@tectonics/prs/incoming-payment';
import { getMainReceipt } from '@tectonics/prs/receipts';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { getSafeInstalmentByNumber } from './get-instalments';

export function useCurrentReceipt(): Receipt {
  const incomingPayment = useIncomingPayment();
  const [selectedPaymentMethodCode] = useUserInputValue('selectedPaymentMethod');
  const [selectedInstalment] = useUserInputValue('selectedInstalment');

  if (getStatus(incomingPayment) !== 'OP' && getStatus(incomingPayment) !== 'CA'  ) {
    return getFinalReceipt(incomingPayment);
  }

  const receipts = getReceipts(incomingPayment);

  if (['creditcard', 'google'].includes(selectedPaymentMethodCode)) {
    return getSafeInstalmentByNumber(receipts, Number(selectedInstalment));
  } else {
    return getMainReceipt(receipts);
  }
}
